export interface IComparable<T> {
	compare(obj: T): boolean;
}
